<template>
  <MgdFormField v-slot="{ componentField, meta }" :name="name">
    <MgdFormItem>
      <FormFieldLabel v-bind="formFieldLabelProps" :required="meta.required" />
      <MgdFormControl>
        <MgdTextarea
          v-bind="{ ...attrs, ...componentField }"
          :disabled="disabled"
          :placeholder="placeholder"
        />
      </MgdFormControl>
      <MgdFormDescription v-if="slots.description">
        <slot name="description" />
      </MgdFormDescription>
      <MgdFormMessage />
    </MgdFormItem>
  </MgdFormField>
</template>

<script setup lang="ts">
import { useFormFieldLabelProps, type FormFieldLabelProps } from "./Label.vue";

const props = defineProps<
  FormFieldLabelProps & {
    placeholder?: string;
  }
>();
const slots = useSlots();
const attrs = useAttrs();
const formFieldLabelProps = useFormFieldLabelProps(props);
</script>
